import React from 'react';
import { ListGroup } from 'flowbite-react';
import { useNavigate } from 'react-router-dom';

const Filter = ({ soluciones = [], onClose, error = '', searchTerm = '' }) => {
  const navigate = useNavigate();

  const handleGoToSolution = (solutionId, fileId, fileCount) => {
    if (fileCount === 0) {
      alert('No existen instaladores disponibles en la solución');
      return;
    }

    const suffix = fileId ? `?instalador=${fileId}` : '';
    navigate(`./solucion/${solutionId}/view${suffix}`);
    onClose(true);
  };

  return (
    <div>
      {error && <p className="mb-3 text-sm text-red-600">{error}</p>}
      {!error && soluciones.length === 0 && (
        <p className="mb-3 text-sm text-gray-600">No se encontraron resultados para "{searchTerm}".</p>
      )}
      <ListGroup className="w-full">
        {soluciones.map((sol) => (
          <ListGroup.Item
            key={`${sol.id}-${sol.primaryFileId || 'none'}`}
            onClick={() => handleGoToSolution(sol.id, sol.primaryFileId, sol.fileCount)}
          >
            <p className="w-full">
              <span className="text-red-500">{sol.name}</span>
            </p>
            <p className="w-full text-gray-400 font-normal">{sol.description}</p>
          </ListGroup.Item>
        ))}
      </ListGroup>
    </div>
  );
};

export default Filter;
